const getters = {
  sidebar: state => state.app.sidebar,
  menu: state => state.app.menu,
  userDetal: state => state.user.userDetal,
  loadingMessage: state => state.app.loadingMessage,
  accessToken: state => state.user.accessToken,
  appToken: state => state.user.appToken,
  getBreadcrumb: state => level => {
    if (state.app.breadcrumb[level]) {
      return state.app.breadcrumb[level];
    } else {
      if (
        localStorage.getItem("breadcrumb") &&
        localStorage.getItem("breadcrumb")[level]
      ) {
        return localStorage.getItem("breadcrumb")[level];
      } else {
        return {};
      }
    }
  }
};
export default getters;
